import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-hotel-dialog',
  templateUrl: './hotel-dialog.component.html',
  standalone: false,
  styleUrls: ['./hotel-dialog.component.scss'],
})
export class HotelDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      dutyPeriodIndex: number;
    },
    private dialog: MatDialog,
  ) {}

  onCloseDialog(): void {
    this.dialog.closeAll();
  }
}
